<template>
	<div class="selector">
		<select :value="value.region" class="select" @change="regionChange">
			<option
				v-for="item in getListAddNull('region', null, '시 / 도')"
				:key="item.id"
				:value="item.id"
			>
				{{ item.name }}
			</option>
		</select>
		<select
			:value="value.location"
			class="select selector__location"
			@change="locationChange"
		>
			<option
				v-for="item in parsedLocationList"
				:key="item.id"
				:value="item.id"
			>
				{{ item.name }}
			</option>
		</select>
	</div>
</template>
<script>
	import _ from 'lodash';
	import { mapGetters } from 'vuex';

	export default {
		name: 'RegionSelector',
		props: {
			value: {
				type: Object,
				default: () => ({
					region: null,
					location: null,
				}),
			},
		},
		data() {
			return {
				locationList: [],
			};
		},
		computed: {
			...mapGetters({
				getListAddNull: 'getListAddNull',
			}),
			parsedLocationList() {
				return [{ id: null, name: '군 / 구' }, ...this.locationList];
			},
		},
		watch: {
			async 'value.region'(region) {
				if (region) {
					await this.getLocationList(region);
					this.$emit('input', {
						region,
						location: this.value.location,
					});
				} else {
					this.locationList = [];
				}
			},
		},
		methods: {
			async getLocationList(region) {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/common/${region}/codes`
					);
					this.locationList = data.data.map(item => ({
						id: item.idCommon,
						name: item.commonText,
					}));
				} catch (err) {
					console.error(err);
				}
			},
			async regionChange({ target }) {
				this.$emit('input', {
					region: Number(target.value) || null,
					location: null,
				});
			},
			locationChange({ target }) {
				this.$emit('input', {
					region: this.value.region,
					location: Number(target.value) || null,
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	DIV.selector {
		display: flex;
		align-items: center;

		.selector__location {
			margin-left: 12px;
		}
	}
</style>
